import { apiSlice } from "../../../../api/ApiService";
import { getHeadersFromRedux } from "../../../../utility/functions/common-functions";
import { RewardProgressWidgetResponse } from "../../../../utility/interfaces/rewardActivityInterfaces";

const rewardProgressWidgetApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getRewardProgressWidget: builder.query<
      RewardProgressWidgetResponse,
      { patientProfileId: number; patientPreferredLang: string }
    >({
      query: ({ patientProfileId, patientPreferredLang }) => {
        const headers = getHeadersFromRedux();
        headers["X-Language"] = patientPreferredLang;
        return {
          url: `/api/v1/Patient/${patientProfileId}/reward-progress-widget`,
          method: "GET",
          headers,
        };
      },
      providesTags: () => [{ type: "RewardProgressWidget" }],
    }),
  }),
  overrideExisting: false,
});

export const { useGetRewardProgressWidgetQuery } = rewardProgressWidgetApi;
export default rewardProgressWidgetApi;
